module.exports = __webpack_public_path__ + "img/1.99b2271b.png";